import './index.less'
import WidgetCard from '../../../../../components/WidgetCard'
import { GeneralIcon } from '../../../components/coloredIcons'
import { IRoleDetails } from '../../../constants'
import { RootState } from '../../../../../rootReducer'
import { updateRoleMetadataDetails } from '../../../slice'
import React from 'react'
import { Input, TextArea, Typography } from '@lightbeamai/design-system'
import { useIntl } from 'react-intl'
import { connect } from 'react-redux'

interface IProps {
  roleDetails: IRoleDetails
  isDetailsView: boolean
  showDisplayNameError?: string
  updateRoleMetadataDetails: (roleDetails: IRoleDetails) => void
}

const WidgetGeneral = (props: IProps) => {
  const {
    roleDetails,
    isDetailsView = false,
    updateRoleMetadataDetails,
    showDisplayNameError
  } = props
  const intl = useIntl()
  return (
    <div className="xs-mb-32 widget-general-container">
      <WidgetCard
        cardBordered={true}
        widgetTitle={{
          title: intl.formatMessage({ id: 'settings.users.addNewUser.widget.title.general' }),
          bordered: true,
          icon: <GeneralIcon />
        }}
      >
        <Typography
          variant="base"
          color="primary"
          as="div"
          className="xs-mb-8 lb-form-label required"
        >
          {intl.formatMessage({ id: 'settings.roles.roleName' })}
        </Typography>
        <Input
          disabled={isDetailsView}
          value={roleDetails?.displayName || ''}
          onChange={(e) => {
            updateRoleMetadataDetails({ displayName: e.target.value })
          }}
          size="middle"
        />
        {showDisplayNameError && (
          <Typography variant="baseMinus2" color="error" as="div" className="xs-mb-8">
            {intl.formatMessage({ id: showDisplayNameError })}
          </Typography>
        )}

        <Typography variant="base" color="primary" as="div" className="xs-mb-8 xs-mt-16">
          {intl.formatMessage({ id: 'settings.roles.roleDescription' })}
        </Typography>
        <TextArea
          disabled={isDetailsView}
          size="middle"
          value={roleDetails?.description || ''}
          onChange={(e) => updateRoleMetadataDetails({ description: e.target.value })}
          className="role-detail-widget-general-text-area"
        />
      </WidgetCard>
    </div>
  )
}

const mapStateToProps = (state: RootState) => ({
  roleDetails: state.configureRoles.roleDetails
})

const mapDispatchToProps = {
  updateRoleMetadataDetails
}

export default connect(mapStateToProps, mapDispatchToProps)(WidgetGeneral)
